import OrganizationList from './OrganizationList';
import {Provider} from './OrganizationContext';

export const Organizations = () => {
  return (
    <Provider>
      <OrganizationList />
    </Provider>
  );
};
